import React,{ useEffect, useState } from "react";
import SigninDetails from "../auth/SigninDetails";

import { default as Seo } from "../../components/SEO";
import { useParams } from "react-router-dom";
import { Button, Textarea } from "@ht/components";
import { useHttpRequest } from "../../hooks/useHttpRequest";

// eslint-disable-next-line react/no-unused-prop-types
export const ChangePasswordContext = React.createContext<any>(null);

const Signin = () => {

    const ticketServiceUrl = process.env.REACT_APP_TICKET_SERVICE;
    const [ticketData, setTicketData] = useState<any>()
    const [followUpResponse, setFollowUpResponse] = useState("")

    const { ticketNumber } = useParams();
    const ticketId = ticketNumber?.split('_')[0]
    const realTicketNumber = ticketNumber?.split('_')[1]
    const [submitted, setSubmitted] = useState(false)
    const { sendRequest } = useHttpRequest(ticketServiceUrl);
    const loadEForm = async () => {

        const result = await sendRequest({
            url: `/ticket/fullstring/${ticketNumber}`,
            method: "get",
        });
        console.log(result?.data)
        setTicketData(result?.data as any);
        setFollowUpResponse((result?.data as any).follow_up_response)
    }
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await sendRequest({
            url: `/ticketresponse`,
            method: "put",
            body: { ticket_id: ticketId, followUpResponse: followUpResponse }
        });
        await loadEForm()
        setSubmitted(true)
    }
    useEffect(() => { loadEForm().catch(() => { }) }, [])
    return (
        <>
            <Seo />
            <div className="signin-wrapper h-screen md:flex bg-gradient-to-br from-primary-600 via-primary to-primary">
                <div className="flex-1 md:min-h-screen  h-full flex justify-center items-center bg-white">
                    <div className="signin-box w-full pt-4 p-[30px] h-[100vh] overflow-y-scroll">
                        {ticketData && !submitted &&
                            <>
                                <h2 className="font-bold">Ticket Response Page</h2>
                                <h3 className="font-light text-md text-gray-400 mb-[50px]">
                                    Please Respond to Ticket #{realTicketNumber}.
                                </h3>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-4 flex flex-col">
                                        <span className='font-semibold text-gray-400 text-base'>Name</span>
                                        <span className='font-semibold text-black text-base'>{ticketData.name}</span>
                                    </div>
                                    <div className="flex flex-row gap-4">
                                        <div className="form-group mb-4 flex flex-col">
                                            <span className='font-semibold text-gray-400 text-base'>Phone Number</span>
                                            <span className='font-semibold text-black text-base'>{ticketData.phone_number}</span>
                                        </div>
                                        <div className="form-group mb-4 flex flex-col">
                                            <span className='font-semibold text-gray-400 text-base'>Email</span>
                                            <span className='font-semibold text-black text-base'>{ticketData.email}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-row gap-4">
                                        <div className="form-group mb-4 flex flex-col">
                                            <span className='font-semibold text-gray-400 text-base'>Category</span>
                                            <span className='font-semibold text-black text-base'>{ticketData.category}</span>
                                        </div>
                                        <div className="form-group mb-4 flex flex-col">
                                            <span className='font-semibold text-gray-400 text-base'>Subcategory</span>
                                            <span className='font-semibold text-black text-base'>{ticketData.subcategory}</span>
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 flex flex-col">
                                        <span className='font-semibold text-gray-400 text-base'>Topic</span>
                                        <span className='font-semibold text-black text-base'>{ticketData.topic}</span>
                                    </div>
                                    <div className="form-group mb-4 flex flex-col">
                                        <span className='font-semibold text-gray-400 text-base'>Station</span>
                                        <span className='font-semibold text-black text-base'>{ticketData.station}</span>
                                    </div>

                                    <div className="form-group mb-4 flex flex-col">
                                        <span className='font-semibold text-gray-400 text-base'>Ticket Details</span>
                                        <Textarea
                                            rows={4}
                                            id="details"
                                            name="details"

                                            className="rounded-md !bg-gray-100 border-0 placeholder-gray-300"
                                            value={ticketData.ticket_details}
                                        />
                                    </div>

                                    <div className="form-group mb-4 flex flex-col">
                                        <span className='font-semibold text-gray-400 text-base'>Response</span>
                                        <Textarea
                                            rows={4}
                                            id="response"
                                            name="response"
                                            placeholder="Enter response"
                                            onChange={(e) => {
                                                setFollowUpResponse(e.target.value)
                                            }}
                                            className="rounded-md !bg-gray-100 border-0 placeholder-gray-300"
                                            value={followUpResponse}
                                        />
                                        <span className='text-danger font-semibold mb-[8px]'></span>
                                    </div>

                                    <div className='flex flex-row-reverse justify-between items-center mb-[18px] mt-[20px]'>
                                        <button
                                            type="button"
                                            onClick={() => {}}
                                            onKeyDown={() => {}}
                                            className="text-base text-gray-400 hover:text-primary hover:cursor-pointer hover:underline"
                                            >
                                        </button>

                                    </div>

                                    <Button
                                        type="submit"
                                        fullwidth
                                        className="rounded-lg text-sm uppercase tracking-wider border-0 min-h-[40px] mb-10 bg-gradient-to-r from-primary to-purple bg-repeat-x"
                                    >
                                        <span className='text-md font-semibold text-white normal-case'>Submit Response</span>
                                    </Button>
                                </form>
                            </>
                        }
                        {ticketData && submitted && String(ticketData.follow_up_response) !== "" &&
                            <div className="flex flex-col">
                                <span className="font-semibold text-black text-lg">
                                    Response has been submitted.
                                </span>
                                <span className="font-semibold text-gray-400 text-md">
                                    Thank you for sending a response
                                </span>

                            </div>
                        }
                    </div>
                </div>

                <div className="flex-1 row-start-2 md:row-start-1 p-[30px] md:flex justify-center items-center hidden ">
                    <SigninDetails />
                </div>

            </div >
        </>
    );
};

export default Signin;
